import { MessageCircle } from "lucide-react";
import { whatsappUrl } from "../data/content";

export default function WhatsAppFloat() {
  return (
    <a
      href={whatsappUrl("Hello CFOSutra, I'd like to discuss your services.")}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with CFOSutra on WhatsApp"
      data-testid="whatsapp-float-btn"
      className="fixed bottom-6 right-6 z-40 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg hover:scale-110 transition-transform duration-200"
    >
      <MessageCircle size={24} />
    </a>
  );
}
